import { Box, Tooltip } from '@mui/material'
import React from 'react'
import { BiQuestionMark } from 'react-icons/bi'
import { IconType } from 'react-icons/lib'
import { TableCellProps } from 'react-virtualized'

interface IIconCell extends TableCellProps {
  icon?: IconType
  tooltip?: string
}

export function IconCell({ icon, tooltip }: IIconCell) {
  const Icon = icon ?? BiQuestionMark

  return (
    <Box display="flex">
      <Tooltip title={tooltip}>
        <Box
          sx={{
            fontSize: '24px',
            color: 'grey.700',
          }}
        >
          <Icon />
        </Box>
      </Tooltip>
    </Box>
  )
}
